import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import { getMonthDeclarations } from './actions/get-month-declaration.action';
import { submitMonthDeclaration } from './actions/submit-month-declaration.action';
import { VenueMonthDeclaration } from './entities/project-venue-month-declaration';

export type ProjectVenueMonthDeclarationState = {
  byMonth: {
    [monthKey: string]: VenueMonthDeclaration;
  };
  isFetching: boolean;
  isSubmiting: boolean;
};

const initialState: ProjectVenueMonthDeclarationState = {
  byMonth: {},
  isFetching: false,
  isSubmiting: false,
};

export const projectVenueMonthDeclarationSlice = createSlice({
  name: 'ProjectVenueMonthDeclaration',
  initialState,
  reducers: {
    clearByMonth(state) {
      state.byMonth = {};
    },
  },
  extraReducers(builder) {
    builder
      // getMonthDeclarations
      .addCase(getMonthDeclarations.fulfilled, (state, action) => {
        state.byMonth = action.payload;
      })
      // isFetching
      .addMatcher(isAnyOf(getMonthDeclarations.pending), (state) => {
        state.isFetching = true;
      })
      .addMatcher(
        isAnyOf(getMonthDeclarations.fulfilled, getMonthDeclarations.rejected),
        (state) => {
          state.isFetching = false;
        },
      )
      // isSubmiting
      .addMatcher(isAnyOf(submitMonthDeclaration.pending), (state) => {
        state.isSubmiting = true;
      })
      .addMatcher(
        isAnyOf(
          submitMonthDeclaration.fulfilled,
          submitMonthDeclaration.rejected,
        ),
        (state) => {
          state.isSubmiting = false;
        },
      );
  },
});
